// English strings for the Outfino Partner Portal.
const en = {
  // ---- Eseménynaptár (community challenge calendar) ----
  'eventCalendar.title': "Event calendar",
  'eventCalendar.lead': "Outfino's daily community challenges: the goal, the timing, the progress and every brand's rewards. Your own partner days and rewards are highlighted.",
  'eventCalendar.prevMonth': "Previous month",
  'eventCalendar.nextMonth': "Next month",
  'eventCalendar.today': "Today",
  'eventCalendar.todayMarker': "Today",
  'eventCalendar.planningWindow': "Planned ahead: {from} – {to}",
  'eventCalendar.loadError': "Could not load the calendar. Try again.",
  'eventCalendar.empty': "No challenges yet",
  'eventCalendar.emptyHint': "The community challenges will show up here — always planned for the next 30 days.",
  'eventCalendar.status.scheduled': "Scheduled",
  'eventCalendar.status.live': "Live",
  'eventCalendar.status.completed': "Completed",
  'eventCalendar.status.failed': "Not completed",
  'eventCalendar.status.draft': "Draft",
  'eventCalendar.tier.normal': "Normal day",
  'eventCalendar.tier.challenge': "Challenge day",
  'eventCalendar.tier.special': "Special event",
  'eventCalendar.mayChange': "Planned, may change",
  'eventCalendar.ownLegend': "Linked to your brand",
  'eventCalendar.hasReward': "Has a reward",
  'eventCalendar.yourPartnerDay': "Your partner day",
  'eventCalendar.yourReward': "Your reward",
  'eventCalendar.mechanic.label': "Reward",
  'eventCalendar.mechanic.all_contributors': "Every contributor gets one",
  'eventCalendar.mechanic.raffle': "Raffle",
  'eventCalendar.mechanic.gift_drop': "Gift crates in the galaxy",
  'eventCalendar.mechanic.wheel_event': "Prize wheel",
  'eventCalendar.mechanic.none': "No reward",
  'eventCalendar.mechanic.short.all_contributors': "Everyone",
  'eventCalendar.mechanic.short.raffle': "Raffle",
  'eventCalendar.mechanic.short.gift_drop': "Crates",
  'eventCalendar.mechanic.short.wheel_event': "Wheel",
  'eventCalendar.mechanic.terms.all_contributors': "When the goal is reached, every contributor gets one (up to {n} people).",
  'eventCalendar.mechanic.terms.raffle': "When the goal is reached, {n} prizes are drawn among the contributors.",
  'eventCalendar.mechanic.terms.gift_drop': "When the goal is reached, {n} gift crates drop into the galaxy for contributors.",
  'eventCalendar.mechanic.terms.gift_drop_anyone': "When the goal is reached, {n} gift crates drop into the galaxy — anyone there may catch one.",
  'eventCalendar.mechanic.terms.wheel_event': "When the goal is reached, the prize wheel opens; every contributor spins ({n} prizes).",
  'eventCalendar.mechanic.completed': "Completed — the eligible set is closed.",
  'eventCalendar.mechanic.completedEarly': "Completed before the day ended — the eligible set is closed; later arrivals missed it.",
  'eventCalendar.goal': "Goal",
  'eventCalendar.when': "When",
  'eventCalendar.progressLabel': "Progress",
  'eventCalendar.progress': "{pct}% of the goal",
  'eventCalendar.partnerDay': "Partner day",
  'eventCalendar.rewards': "Rewards",
  'eventCalendar.noRewards': "A challenge without a reward.",
  'eventCalendar.rewardType.gift_rain': "Gift rain",
  'eventCalendar.rewardType.cart_coupon': "Cart coupon",
  'eventCalendar.rewardType.wheel_spin': "Wheel spin",
  'eventCalendar.quantity': "{n} pcs",
  'eventCalendar.rewardStatus.planned': "planned",
  'eventCalendar.rewardStatus.reserved': "reserved",
  'eventCalendar.rewardStatus.published': "published",
  'eventCalendar.rewardStatus.released': "released",
  'eventCalendar.rewardStatus.granted': "granted",
  'eventCalendar.metric.ratings_count': "Outfit ratings",
  'eventCalendar.metric.ootd_entries': "OOTD entries",
  'eventCalendar.metric.ootd_likes': "OOTD likes",
  'eventCalendar.metric.wardrobe_items': "New wardrobe items",
  'eventCalendar.metric.galaxy_moves': "Galaxy activity",
  'eventCalendar.metric.brand_visits': "Brand visits",
  'eventCalendar.metric.product_views': "Product views",
  'eventCalendar.metric.product_likes': "Product likes",
  'eventCalendar.metric.invites_accepted': "Accepted invites",

  // ---- Prize Pool ----
  'eventCalendar.prizePoolLead': "Your brand can offer rewards for the community challenges.",
  'eventCalendar.prizePoolLink': "Open the Prize Pool",
  'prizePool.title': "Prize Pool",
  'prizePool.lead': "Offer coupons and gift crates for Outfino's daily community challenges, with a monthly quantity cap. Month by month you see how often your reward was selected and how often it was granted.",
  'prizePool.prevMonth': "Previous month",
  'prizePool.nextMonth': "Next month",
  'prizePool.new': "New offer",
  'prizePool.newTitle': "New offer",
  'prizePool.editTitle': "Edit offer",
  'prizePool.create': "Offer it",
  'prizePool.save': "Save",
  'prizePool.cancel': "Cancel",
  'prizePool.edit': "Edit",
  'prizePool.withdraw': "Withdraw",
  'prizePool.withdrawBlocked': "Cannot be withdrawn: reserved for {days}",
  'prizePool.withdrawConfirmTitle': "Withdraw this offer?",
  'prizePool.withdrawConfirmBody': "“{name}” leaves the Prize Pool: the bot can no longer pick it as a reward. This cannot be undone.",
  'prizePool.withdrawConfirmCancel': "Cancel",
  'prizePool.reservedEditNote': "This offer is already reserved for a challenge: what the reserved reward promises (type, discount, products, combinability) cannot change. The name can change, caps can only grow and the validity can only be extended.",
  'prizePool.empty': "No offers yet. Your rewards show up here, with monthly stats.",
  'prizePool.type.cart_coupon': "Cart coupon",
  'prizePool.type.gift_rain': "Gift crate (products)",
  'prizePool.type.wheel_spin': "Wheel prize",
  'prizePool.status.offered': "Offered",
  'prizePool.status.reserved': "Reserved",
  'prizePool.status.withdrawn': "Withdrawn",
  'prizePool.status.expired': "Expired",
  'prizePool.combinableTag': "combinable",
  'prizePool.rate': "Granted in {granted} of {decided} events",
  'prizePool.rateNone': "No closed event this month yet",
  'prizePool.selected': "selected {n}×",
  'prizePool.notCompleted': "{n} not completed",
  'prizePool.used': "{n} granted",
  'prizePool.held': "{n} reserved",
  'prizePool.remaining': "{n} left of the monthly {cap}",
  'prizePool.noCap': "no monthly cap",
  'prizePool.heldDays': "Reserved days",
  'prizePool.pcs': "pcs",
  'prizePool.field.title': "Name",
  'prizePool.field.type': "Type",
  'prizePool.field.discountType': "Discount",
  'prizePool.field.percent': "Percent (%)",
  'prizePool.field.amount': "Amount",
  'prizePool.field.currency': "Currency",
  'prizePool.field.minCart': "Minimum cart value (to redeem)",
  'prizePool.field.maxUses': "Max. uses (in total)",
  'prizePool.field.monthlyCap': "Monthly cap (pcs)",
  'prizePool.field.validFrom': "Valid from",
  'prizePool.field.validUntil': "Valid until (expiry)",
  'prizePool.field.combinable': "Combinable with my own sales",
  'prizePool.field.products': "Products ({n} selected)",
  'prizePool.field.product_ids': "products",
  'prizePool.field.discount_value': "amount",
  'prizePool.field.discount_type': "discount",
  'prizePool.field.min_cart_value': "minimum cart value",
  'prizePool.field.max_uses': "max. uses",
  'prizePool.field.valid_until': "expiry",
  'prizePool.productSearch': "Search your products…",
  'prizePool.noProducts': "No match.",
  'prizePool.discount.none': "— products only —",
  'prizePool.discount.percent': "Percent",
  'prizePool.discount.fixed': "Fixed amount",
  'prizePool.preview.title': "Maximum discount",
  'prizePool.preview.percent': "The coupon gives at most {max}% off.",
  'prizePool.preview.percentStacked': "Stacked on your own {sale}% sale: at most {max}% (the {coupon}% applies to the already reduced price).",
  'prizePool.preview.fixed': "{amount} off from a cart of at least {min} — so at most {share}% of the cart value.",
  'prizePool.preview.combinable': "Combinable with your own sales.",
  'prizePool.preview.notCombinable': "Not combinable with your own sales (the default).",
  'prizePool.problem.products': "Pick at least one product.",
  'prizePool.problem.discount': "Choose the discount type.",
  'prizePool.problem.value': "Enter a valid amount.",
  'prizePool.problem.currency': "A fixed amount needs a currency (e.g. HUF).",
  'prizePool.problem.minCart': "A fixed amount needs a minimum cart value above the discount.",
  'prizePool.problem.maxUses': "A fixed amount needs a maximum number of uses (a positive whole number).",
  'prizePool.problem.validUntil': "A fixed amount needs an expiry.",
  'prizePool.problem.cap': "The monthly cap is a positive whole number.",
  'prizePool.problem.validity': "The validity cannot end before it starts.",
  'prizePool.error.offer_reserved': "Not possible: it is reserved for {days}",
  'prizePool.error.offer_version_conflict': "The offer changed in the meantime — refresh the page.",
  'prizePool.error.offer_not_available': "This offer is no longer active (withdrawn or expired).",
  'prizePool.error.offer_not_found': "Offer not found.",
  'prizePool.error.invalid_parameters': "Invalid field: {field}",
  'prizePool.error.INSUFFICIENT_PERMISSIONS': "You do not have permission for this (campaign management).",
  'prizePool.error.generic': "That did not work. Try again.",
  'prizePool.howTitle': "How does the event bot work?",
  'prizePool.how.day': "Outfino's community takes on one shared challenge a day, from 09:00 to midnight (Budapest time). Every challenge is about activity: outfit ratings, OOTD, exploring the galaxy and brands, viewing products.",
  'prizePool.how.pool': "Challenge rewards come only from approved stock: partners' Prize Pool offers and Outfino's own budget. The event bot does not invent rewards, it only picks from these.",
  'prizePool.how.contributors': "Only people who contributed to the challenge that day can get a reward.",
  'prizePool.how.noPurchase': "Neither the challenge nor winning a reward ever depends on a purchase. Redeeming a coupon naturally needs a purchase — winning it never does.",
  'prizePool.how.released': "If a challenge is not completed, the reward reserved for it is released and does not count against your monthly cap.",
  'prizePool.how.partnerDays': "A few partner days a month are built around one brand — their goals are about activity too.",
  'prizePool.how.benefits': "Your reward and your brand show up on the 3D Style Universe's challenge board and in the event calendar; on a partner day your brand is at the centre.",
  'prizePool.how.withdraw': "You can withdraw an offer at any time until it is reserved: rewards are only reserved for challenges from the next day on. A reserved or published reward can no longer be withdrawn.",
  'prizePool.how.combinable': "By default your coupon does not stack with your own sales; you can allow it per coupon and see the maximum discount it can lead to here.",

  // ---- Nav ----
  'nav.what': 'How it works',
  'nav.why': 'Why partner',
  'nav.dashboard': 'Dashboard',
  'nav.login': 'Log in',

  // ---- Hero ----
  'hero.badge': 'Outfino for Brands',
  'hero.title': 'Turn Your Brand Into a Personalized Shopping Experience',
  'hero.subtitle':
    'Outfino helps fashion brands reach customers in a completely new way. Instead of showing products to everyone, we connect your collections with people whose personal style actually matches your brand.',
  'hero.ctaLogin': 'Log in',
  'hero.ctaLearn': 'Learn more',

  // ---- What it does ----
  'what.eyebrow': 'How it works',
  'what.title': 'Reach the people who’ll actually love your products',
  'what.body':
    'Our AI understands each user’s unique fashion preferences and recommends products they’re genuinely likely to love — creating a more relevant shopping experience and higher-quality traffic for your store.',

  // ---- Why partner ----
  'why.eyebrow': 'Why partner with Outfino?',
  'why.title': 'Higher-intent customers, not just more clicks',
  'why.audience.title': 'Reach the right audience',
  'why.audience.body':
    'Your products are recommended to users whose style matches your brand.',
  'why.intent.title': 'Higher purchase intent',
  'why.intent.body':
    'Personalized recommendations lead to more engaged customers.',
  'why.visibility.title': 'Increase visibility',
  'why.visibility.body':
    'Appear across AI recommendations, outfit analyses, and style discovery.',
  'why.insights.title': 'Performance insights',
  'why.insights.body':
    'Understand how users interact with your brand and products.',
  'why.integration.title': 'Easy integration',
  'why.integration.body':
    'Connect your Shopify store and keep your catalog automatically synced.',

  // ---- Your Brand Dashboard ----
  'dash.eyebrow': 'Your Brand Dashboard',
  'dash.title': 'Manage your brand in one place',
  'dash.subtitle': 'Everything you need to grow with Outfino.',
  'dash.profile.title': 'Edit your brand profile',
  'dash.profile.body': 'Keep your brand name, description and logo up to date.',
  'dash.sync.title': 'Sync your products',
  'dash.sync.body': 'Connect Shopify and keep your catalog automatically in sync.',
  'dash.track.title': 'Track performance',
  'dash.track.body': 'Follow clicks, views and conversions across Outfino.',
  'dash.campaigns.title': 'Create offers & campaigns',
  'dash.campaigns.body': 'Launch exclusive offers to the audiences that fit you.',
  'dash.performance.title': 'Monitor your results',
  'dash.performance.body': 'See revenue and payouts in a single dashboard.',

  // ---- CTA ----
  'cta.title': 'Join the next generation of AI-powered fashion discovery',
  'cta.body':
    'Help users find products they’ll actually love. Become an Outfino Partner today.',
  'cta.become': 'Become a partner',
  'cta.contactSales': 'Contact sales',

  // ---- Footer ----
  'footer.tagline': 'Personalized fashion discovery for the brands people love.',
  'footer.product': 'Product',
  'footer.company': 'Company',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.rights': 'All rights reserved.',

  // ---- Login ----
  'login.back': 'Back to home',
  'login.title': 'Partner Portal',
  'login.subtitle': 'Log in to manage your brand.',
  'login.email': 'Email address',
  'login.password': 'Password',
  'login.submit': 'Log in',
  'login.loading': 'Logging in…',
  'login.wrongCredentials': 'Incorrect email or password.',
  'login.networkError': 'Network error. Please try again.',
  'login.notice': 'Use your Outfino account to sign in.',
  'login.google': 'Sign in with Google',
  'login.apple': 'Sign in with Apple',
  'login.or': 'or',
  'login.googleFailed': 'Google sign-in failed.',
  'login.googleCloseWindow': 'Signed in. You can close this window.',
  'login.appleUnavailable': 'Apple sign-in is unavailable.',
  'login.appleFailed': 'Apple sign-in failed.',

  // ---- Dashboard shell ----
  'shell.brand': 'Brand',
  'shell.envDev': 'DEV',
  'shell.logout': 'Log out',
  'shell.loading': 'Loading…',
  'shell.refresh': 'Refresh',
  'group.mobile': 'Outfino Mobile App',
  'tab.embedded-stats': 'Statistics',
  'tab.embedded-visitors': 'Visitors',
  'shell.comingSoon': 'Coming soon.',
  'sidebar.expand': 'Expand',
  'sidebar.collapse': 'Collapse',
  'sidebar.menu': 'Menu',
  'sidebar.menuClose': 'Close menu',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.lightTitle': 'Light theme',
  'theme.darkTitle': 'Dark theme',
  'lang.name': 'English',
  'lang.switchTitle': 'Switch to Hungarian',
  'shell.connectedReturn': 'Your store is connected to Outfino.',
  'shell.openPortal': 'Go to Outfino Partners',
  'shell.notLinked': 'This store is not linked to an Outfino account yet.',
  'shell.linkAccount': 'Link in Outfino Partners',
  'shell.openInShopifyAdmin': 'Shopify admin',
  'return.title': 'Your store is connected',
  'return.body':
    'Carry on in the Outfino partner portal — your brand, products and payouts are managed there.',
  'shell.embeddedNoSession':
    'Open this page from your Shopify admin, under Apps › Outfino.',

  // ---- No brand yet ----
  'empty.title': 'You don’t have a brand yet',
  'empty.body':
    'Connect your Shopify store to create your brand on Outfino. We’ll import your products and set everything up automatically.',
  'empty.create': 'Add a new brand',

  // ---- Connect Shopify modal ----
  'shopify.title': 'Connect Shopify',
  'shopify.body':
    'Enter your Shopify store domain to connect it. You’ll be redirected to Shopify to approve access, then brought back here.',
  'shopify.shopLabel': 'Shopify store domain',
  'shopify.shopPlaceholder': 'your-store.myshopify.com',
  'shopify.connect': 'Connect',
  'shopify.cancel': 'Cancel',
  'shopify.invalid': 'Please enter a valid .myshopify.com domain.',

  // ---- Linking a store back from Shopify ----
  'connect.linking': 'Attaching the store to your account…',
  'connect.syncing': 'Syncing…',
  'connect.syncingHint': 'Linking the store to your Outfino account. This only takes a few seconds.',
  'connect.returning': 'Taking you to Outfino Partners…',
  'connect.returningHint': 'This store is not linked to an Outfino account yet. Sign in to Outfino Partners to link it.',
  'connect.returningLink': 'Continue to Outfino Partners',
  'connect.failed': 'Could not attach the store. Try again with “Add a brand”.',
  'connect.alreadyLinked': 'This store already belongs to another Outfino account.',

  // ---- Shopify connection banner (documents#637) ----
  // Shown above every brand page while stores[].shopifyConnection.status is not
  // CONNECTED. The CTA opens the Outfino app inside the merchant's Shopify
  // admin (reauth_url) — opening it runs a fresh token exchange.
  'connection.reauthTitle':
    'The Shopify connection was interrupted — open the Outfino app in your Shopify Admin to reconnect.',
  'connection.reauthCta': 'Open the Outfino app in Shopify',
  'products.inactive': 'Inactive',
  'brandInactive.title': 'This brand is currently inactive.',
  'brandInactive.body': 'Its products are not shown in the Outfino app and cannot be bought.',
  'brandInactive.contact': 'To reactivate it, contact the Outfino admins.',
  'brandInactive.cta': 'Contact us',
  'brandInactive.mailSubject': 'Inactive brand',
  'connection.disconnectedTitle': 'The Outfino app is not installed in this store.',
  'connection.disconnectedCta': 'Install / reconnect',
  'connection.lastOk': 'Last successful: {time}',
  'connection.lastOkNever': 'No successful connection recorded yet',
  'connection.err.tokenExpired': 'The Shopify access token has expired.',
  'connection.err.tokenRejected': 'Shopify rejected or revoked the access token.',
  'connection.err.scopeMissing':
    'A permission is missing ({scope}) — grant it by opening the app.',
  'connection.err.uninstalled': 'The app was uninstalled from the store.',
  'connection.err.generic': 'Reason: {code}',

  // ---- Brand dashboard tabs ----
  'tab.profile': 'Profile',
  'tab.products': 'Products',
  'tab.stats': 'Statistics',
  'tab.orders': 'Orders',
  'orders.title': 'Orders',
  'orders.hint': 'Everything sold through Outfino that is yours to fulfil. Amounts are your share after commission.',
  'orders.loading': 'Loading orders…',
  'orders.loadError': 'Could not load your orders.',
  'orders.empty': 'No orders yet.',
  'orders.units': '{n} items',
  'orders.subtotal': 'Products',
  'orders.shipping': 'Shipping',
  'orders.yourShare': 'Your share (after {n}% commission)',
  'orders.method': 'Shipping method',
  'orders.deliverTo': 'Deliver to',
  'orders.shopifyOrder': 'Shopify order',
  'orders.noShopifyOrder': 'Not created in Shopify',

  // ---- Shipping (#623 B4 — read-only; Shopify is the only source) ----
  'tab.shipping': 'Shipping',
  'shipping.title': 'Shipping coverage',
  'shipping.source': 'We read your shipping countries and methods from your Shopify settings.',
  'shipping.sourceHowTo': 'To change where you ship or what it costs, edit them in your Shopify Admin (Settings → Shipping and delivery). Changes reach Outfino automatically, or use Refresh.',
  'shipping.refresh': 'Refresh',
  'shipping.refreshing': 'Refreshing…',
  'shipping.loading': 'Loading shipping coverage…',
  'shipping.loadError': 'Could not load your shipping coverage.',
  'shipping.noCoverage': 'No shipping zones found in your Shopify settings yet.',
  'shipping.countryCount': '{n} countries',
  'shipping.restOfWorldChip': 'Rest of world',
  'shipping.zoomIn': 'Zoom in',
  'shipping.zoomOut': 'Zoom out',
  'shipping.legendCovered': 'Ships here (from Shopify)',
  'shipping.legendRestOfWorld': 'Rest of world — every other country',
  'shipping.legendNone': 'No shipping',
  'shipping.pickCountry': 'Select a highlighted country to see the shipping methods available there.',
  'shipping.shopifyMethodsHead': 'Shopify methods',
  'shipping.methodsLoading': 'Loading methods…',
  'shipping.methodsError': 'Could not load the methods for this country.',
  'shipping.methodsEmpty': 'No shipping methods available for this country.',
  'shipping.methodsEmptyButCovered': 'Your Shopify settings cover this country, but Shopify returned no specific method for it right now.',
  'shipping.methodsEmptyCheckoutHint': 'The exact fee is calculated by Shopify for the buyer’s address at checkout.',
  'shipping.priceAtCheckout': 'Price at checkout',
  'shipping.notConnectedTitle': 'Connect your Shopify store',
  'shipping.notConnectedBody': 'Connect your Shopify store to see the countries and methods you ship with.',
  'shipping.accessDeniedTitle': 'Reconnect your Shopify store',
  'shipping.accessDeniedBody': 'We can’t read your shipping settings — your Shopify connection is missing the shipping permission. Please reconnect the store to grant it.',
  'shipping.genericErrorTitle': 'Shipping unavailable',
  'shipping.genericErrorBody': 'We couldn’t read your shipping settings from Shopify right now. Please try again later.',
  // documents#637 — the store's token was rejected (error: shopify_reauth_required),
  // or the read_shipping scope was never granted (shipping_access_denied +
  // reason: scope_missing:read_shipping).
  'shipping.reauthTitle': 'Reconnect your Shopify store',
  'shipping.reauthBody':
    'The Shopify connection was interrupted — open the Outfino app in your Shopify Admin to reconnect.',
  'shipping.scopeMissingTitle': 'Permission needed to read shipping',
  'shipping.scopeMissingBody':
    'Reading your shipping settings needs a permission — open the Outfino app in your Shopify Admin and accept the requested permission.',
  'shipping.openShopifyApp': 'Open the Outfino app in Shopify',
  // #623 — state of the cached coverage shoppers are filtered on.
  'shipping.statusValid': 'In sync with Shopify — last updated {time}',
  'shipping.statusStale': 'Not updated for {days} days — check your Shopify connection',
  'shipping.statusStaleNoDate': 'Coverage data may be outdated — check your Shopify connection',
  'shipping.statusUnknown': 'Could not read your Shopify shipping settings — open the Outfino app in your Shopify Admin or check its permissions',

  'tab.payouts': 'Payouts',
  'tab.members': 'Members',
  'tab.drops': 'Drops',
  'tab.campaigns': 'Creator campaigns',
  'tab.challenges': 'Challenges',
  'tab.special': 'Advanced',

  // ---- Creator campaigns ----
  'campaigns.title': 'Creator campaigns',
  'campaigns.new': 'New brief',
  'campaigns.empty': 'You haven’t created a brief yet. Start with your first!',
  'campaigns.back': 'Back',
  'campaigns.applicantsCount': '{count} applicants',
  'campaigns.selectedCount': '{done}/{total} selected',
  'campaigns.applicants': 'Applicants',
  'campaigns.noApplicants': 'No one has applied to this brief yet.',
  'campaigns.selected': 'Selected',
  'campaigns.select': 'Select',
  'campaigns.deselect': 'Deselect',
  'campaigns.slots': '{count} creators needed',
  'campaigns.videos': '{count} videos / creator',
  'campaigns.applyDeadline': 'Application deadline',
  'campaigns.deliveryDeadline': 'Delivery deadline',
  'campaigns.status.open': 'Open',
  'campaigns.status.selecting': 'Selecting',
  'campaigns.status.in_progress': 'In progress',
  'campaigns.status.completed': 'Completed',
  'campaigns.newTitle': 'Create a new brief',
  'campaigns.fTitle': 'Title',
  'campaigns.fDescription': 'Description',
  'campaigns.fSlots': 'How many creators?',
  'campaigns.fVideos': 'Videos / creator',
  'campaigns.fPayment': 'Payment',
  'campaigns.fPaymentPh': 'e.g. Reward per approved video + bonus',
  'campaigns.create': 'Create brief',
  'campaigns.creating': 'Creating...',
  'campaigns.cancel': 'Cancel',
  'campaigns.fAmount': 'Amount',
  'campaigns.fAmountPh': 'e.g. 150',
  'campaigns.fCurrency': 'Currency',
  'campaigns.loading': 'Loading campaigns...',
  'campaigns.error': 'Could not load campaigns. Please try again.',

  // ---- Brand profile ----
  'profile.title': 'Brand profile',
  'profile.logo': 'Change logo',
  'profile.cover': 'Change cover',
  'profile.coverHint': 'Add a cover image',
  'profile.name': 'Brand name',
  'profile.company': 'Company name',
  'profile.tagline': 'Tagline',
  'profile.taglineHint': 'One line under your brand name in the app (max 140 characters)',
  'profile.description': 'Description',
  'profile.phone': 'Phone number',
  'profile.website': 'Website',
  'profile.address': 'Address',
  'profile.iban': 'IBAN (for payouts)',
  'profile.visibility': 'Brand is visible in Outfino',
  'profile.save': 'Save changes',
  'profile.saving': 'Saving…',
  'profile.saved': 'Saved.',
  'profile.saveError': 'Could not save. Please try again.',
  'profile.readOnly': 'You don’t have permission to edit this brand.',

  // ---- Products ----
  'products.title': 'Products',
  'products.empty': 'No products yet. Sync your Shopify catalog to import them.',
  'products.sync': 'Sync products',
  'products.syncing': 'Syncing…',
  'products.syncStarted': 'Sync started — this can take a moment.',
  'products.openInShopify': 'Open in Shopify',
  'products.search': 'Search products',
  'products.noMatch': 'No products match your search.',
  'products.loadError': 'Could not load products.',
  'products.retry': 'Try again',
  'products.soldOut': 'Sold out',
  'products.stockCount': '{n} in stock',
  'products.stockUntracked': 'Stock not tracked',
  'products.stockVariantsOut': '{out} of {total} variants sold out',
  // #615 — sync progress + the products the classifier left out.
  'products.syncProgress': 'Syncing products',
  'products.syncCount': '{done} of {total}',
  'products.syncPreparing': 'Reading your catalogue…',
  'products.excludedTitle': 'Not recognised as clothing',
  'products.excludedHint':
    'These products synced, but the classifier did not recognise them as clothing, so they do not appear to shoppers on Outfino.',
  // documents#188 — per-product AI labelling status (ai_labeling on the list).
  'products.labelPending': 'Labelling in progress…',
  'products.labelDone': 'Labelled',
  'products.labelDoneCategory': 'Labelled: {category}',
  'products.labelFailed': 'Labelling failed',
  'products.labelSkipped': 'Cannot be labelled',
  'products.labelRetry': 'Retry',
  'products.labelRetrying': 'Queuing…',
  'products.labelNotLabelable': 'This product cannot be labelled (deleted or has no Shopify data).',
  'products.labelRetryFailed': 'Could not queue the labelling. Try again.',
  'products.disputeAction': 'Wrong classification?',
  'products.disputeTitle': 'Report wrong classification',
  'products.disputeVerdictNotClothing': 'AI says: not clothing',
  'products.disputeAskClothing': 'You are asking for a review to mark this product as clothing.',
  'products.disputeMessage': 'Message (optional)',
  'products.disputeMessageHint': 'Why do you think the classification is wrong?',
  'products.disputeSubmit': 'Request review',
  'products.disputeSending': 'Sending…',
  'products.disputeCancel': 'Cancel',
  'products.disputePending': 'Review pending',
  'products.disputeRejected': 'Request rejected',
  'products.disputeSentOn': 'Sent on {date}',
  'products.disputeApprovedAs': 'Now listed as clothing',
  'products.disputeApprovedAsCategory': 'Now listed as clothing · {category}',
  'products.disputeNoReason': 'The admin gave no reason.',
  'products.disputeAgain': 'Ask again',
  'products.disputeApproved': 'Request approved',
  'products.disputeNotDisputable': 'This product cannot be disputed right now (deleted, or still being labelled).',
  'products.disputeFailed': 'Could not send the request. Try again.',

  // ---- Drops ----
  'drops.title': 'Drops',
  'drops.empty': 'No drops yet.',
  'drops.status.scheduled': 'Scheduled',
  'drops.status.active': 'Active',
  'drops.status.completed': 'Completed',
  'drops.status.cancelled': 'Cancelled',
  'drops.new': 'New drop',
  'drops.cancel': 'Cancel',
  'drops.cancelFailed': 'Could not cancel the drop. Try again.',
  'drops.exclusiveBadge': 'Outfino Exclusive',
  'drops.form.title': 'New drop',
  'drops.form.products': 'Products',
  'drops.form.productsHint': 'Pick the products to drop. Only clothing products that are Draft or Unlisted in your Shopify store can be scheduled.',
  'drops.form.search': 'Search products',
  'drops.form.noProducts': 'Nothing to schedule: no Draft or Unlisted clothing product that is not already in a drop. Set a product to Draft or Unlisted in Shopify and sync your products to schedule it.',
  'drops.form.selected': '{n} selected',
  'drops.form.date': 'Drop date and time',
  'drops.form.create': 'Schedule drop',
  'drops.form.where': 'Where should it go live?',
  'drops.form.modeExclusive': 'Outfino Exclusive',
  'drops.form.modeExclusiveHint': 'Only on Outfino. The products stay Draft/Unlisted in your Shopify webshop.',
  'drops.form.modeBoth': 'Outfino + my webshop',
  'drops.form.modeBothHint': 'We also set the products to Active in your Shopify store at the drop time.',
  'drops.form.noDate': 'No date yet',
  'drops.form.close': 'Close',
  'drops.form.creating': 'Scheduling…',
  'drops.form.failed': 'Could not schedule the drop. Try again.',
  'drops.form.created': '{n} product(s) scheduled.',
  'drops.form.createdSkipped': '{n} product(s) scheduled, {skipped} skipped (already in a drop, not clothing, or no longer Draft/Unlisted).',

  // ---- Stats ----
  'stats.title': 'Statistics',
  'stats.available': 'Available balance',
  'stats.totalEarned': 'Total earned',
  'stats.thisMonth': 'This month',
  'stats.orders': 'Orders',
  'stats.revenue': 'Revenue',
  'stats.payouts': 'Payouts',
  'stats.noPayouts': 'No payouts yet.',
  'stats.period.day': 'Day',
  'stats.period.week': 'Week',
  'stats.period.month': 'Month',
  'stats.period.year': 'Year',
  'stats.period.all': 'All time',

  // ---- Payouts ----
  'payouts.title': 'Payouts',
  'payouts.request': 'Request payout',
  'payouts.requesting': 'Requesting…',
  'payouts.requested': 'Payout request sent.',
  'payouts.requestError': 'Could not send the request. Please try again.',
  'payouts.pending': 'Pending',
  'payouts.history': 'Payout history',
  'payouts.commissionNote': 'after {pct}% Outfino commission',
  'payouts.breakdownTitle': 'Revenue breakdown',
  'payouts.gross': 'Gross revenue',
  'payouts.commissionLine': 'Outfino commission ({pct}%)',
  'payouts.net': 'Net — yours',

  // ---- Members ----
  'members.title': 'Members',
  'members.empty': 'No members yet.',
  'members.anonymous': 'Anonymous',
  'members.role.owner': 'Owner',
  'members.role.member': 'Member',
  'members.add': 'Add member',
  'members.devLocked': 'Development brands cannot take on new members.',
  'members.searchPlaceholder': 'Search by username…',
  'members.searchEmpty': 'No matches.',
  'members.remove': 'Remove',

  // ---- Permissions ----
  'perm.viewProducts': 'View products',
  'perm.editProducts': 'Edit products',
  'perm.viewOrders': 'View orders',
  'perm.viewAnalytics': 'View analytics',
  'perm.manageMembers': 'Manage members',
  'perm.manageCampaigns': 'Manage campaigns',
  'perm.editBrand': 'Edit brand',
  'perm.manageBilling': 'Manage billing',

  // ---- Danger zone (delete brand) ----
  'danger.title': 'Danger zone',
  'danger.deleteBrand': 'Remove this brand',
  'danger.deleteBody': 'Outfino is uninstalled from your Shopify store, your products disappear from Outfino, and every member, you included, is removed from the brand. Whoever connects the store next becomes its new owner. This cannot be undone.',
  'danger.confirm': 'Are you sure you want to remove {name}? This cannot be undone.',
  'danger.error': 'Could not remove the brand. Please try again.',
  'danger.deleting': 'Removing…',
  // ---- Challenges / galaxy gift drops (GiftDropsTab) ----
  'gifts.title': 'Gift chest in the galaxy',
  'gifts.lead': 'Drop a chest into the Outfino app’s Style Universe galaxy. It drifts in from beyond the rim, crosses the galaxy in about 100 seconds, and the first person to tap it takes it. If nobody catches it, it drifts out.',
  'gifts.dropButton': 'Drop a gift into the galaxy',
  'gifts.dropped': 'Your chest is on its way into the galaxy.',
  'gifts.cancelled': 'The chest has been withdrawn.',
  'gifts.activeTitle': 'Active chests',
  'gifts.polling': 'Refreshing every {s} s',
  'gifts.pollingTitle': 'The page refreshes by itself — more often while a chest is in the galaxy.',
  'gifts.live': 'Live',
  'gifts.liveTitle': 'Live connection: changes show up at once.',
  'gifts.err.brandInactive': 'Your brand is not visible on Outfino right now, so it cannot drop chests.',
  'gifts.err.notEligible': 'This brand cannot drop chests into the galaxy right now.',
  'gifts.err.followersOnly': 'Only the brand\'s followers can catch this chest.',
  'gifts.err.brandNotFound': 'This brand could not be found.',
  'gifts.followersOnly': 'Followers only',
  'gifts.followersOnlyTitle': 'Only your brand\'s followers can catch it; everyone else sees it chained shut.',
  'gifts.modal.followersOnly': 'Followers only',
  'gifts.modal.followersOnlyHint': 'People who don\'t follow the brand see the chest chained shut and cannot catch it.',
  'gifts.retry': 'Retry',
  'gifts.noActive': 'You have no chest in the galaxy right now.',
  'gifts.historyTitle': 'History',
  'gifts.noHistory': 'You haven’t dropped a chest yet.',
  'gifts.loadMore': 'Load more',
  'gifts.someone': 'Someone',
  'gifts.seconds': '{n} s',
  'gifts.cancel': 'Withdraw',
  'gifts.cancelTitle': 'Withdraw this chest?',
  'gifts.cancelText': 'The chest dropped at {at} disappears from the galaxy at once, and nobody can catch it. This cannot be undone.',
  'gifts.cancelling': 'Withdrawing…',
  'gifts.cancelConfirm': 'Yes, withdraw it',
  'gifts.phase.incoming': 'drifting into the galaxy',
  'gifts.phase.inside': 'to the rim',
  'gifts.phase.leaving': 'drifting out of the galaxy',
  'gifts.status.active': 'Active',
  'gifts.status.collected': 'Caught',
  'gifts.status.expired': 'Drifted out',
  'gifts.status.cancelled': 'Withdrawn',
  'gifts.col.createdAt': 'Created',
  'gifts.col.status': 'Status',
  'gifts.col.winner': 'Winner',
  'gifts.col.reaction': 'Reaction time',
  'gifts.col.crossing': 'Crossing',
  'gifts.modal.title': 'Drop a gift into the galaxy',
  'gifts.modal.logoTitle': 'Your logo is on the chest',
  'gifts.modal.logoText': 'Everyone watching the galaxy in the app sees it.',
  'gifts.modal.text': 'The chest drifts in from beyond the galaxy’s rim, crosses it rim to rim in about 100 seconds, and the first person to tap it in the Outfino app takes it. If nobody catches it, it drifts out.',
  'gifts.modal.reward': 'Gift',
  'gifts.modal.rewardSoon': 'Gift (coupon) — coming soon',
  'gifts.modal.rewardHint': 'Soon you can put a coupon in the chest. Until then it drifts without a gift.',
  'gifts.modal.note': 'Note (optional)',
  'gifts.modal.notePlaceholder': 'E.g. autumn campaign — only your team sees it',
  'gifts.modal.back': 'Cancel',
  'gifts.modal.dropping': 'Dropping…',
  'gifts.modal.confirm': 'Drop it',
  'gifts.err.galaxyFull': 'There are too many chests in the galaxy right now. Try again in a few minutes.',
  'gifts.err.notActive': 'This chest is no longer in the galaxy.',
  'gifts.err.notActiveStatus': 'This chest is no longer in the galaxy ({status}).',
  'gifts.err.notFound': 'This chest could not be found.',
  'gifts.err.invalid': 'Something in the form is not valid. Check the note and try again.',
  'gifts.err.disabled': 'Dropping chests is not available right now.',
  'gifts.err.forbidden': 'You don’t have permission to drop chests for this brand.',
  'gifts.err.auth': 'Your session has expired. Please log in again.',
  'gifts.err.rateLimited': 'Too many requests at once. Wait a moment and try again.',
  'gifts.err.network': 'We can’t reach the server. Check your connection and try again.',
  'gifts.err.unavailable': 'This feature is not available here yet.',
  'gifts.err.genericCode': 'Something went wrong ({code}). Please try again.',
  'gifts.err.generic': 'Something went wrong. Please try again.',
  'gifts.modal.prize': 'Prize (optional)',
  'gifts.modal.prizeHint': 'Whoever catches the chest gets these products of yours free in their cart (1 of each, up to {max} products).',
  'gifts.modal.prizeAdd': 'Add a product',
  'gifts.prize.label': 'Prize',
  'gifts.prize.none': 'No prize',
  'gifts.prize.freeShip': 'free shipping',
  'gifts.col.prize': 'Prize',
  'gifts.err.freeShipping': 'To drop a chest with products, accept that shipping is free (you cover its cost).',
  'gifts.err.product.product_not_found': 'One of the products could not be found. Pick the products again.',
  'gifts.err.product.product_inactive': 'One of the products is not active, so it can\'t be a prize.',
  'gifts.err.product.product_out_of_stock': 'One of the products is out of stock, so it can\'t be a prize.',
  'gifts.err.product.duplicate_product': 'The same product is in there twice.',
  'gifts.err.product.too_many_products': 'A chest can hold 5 products at most.',
  // ---- Challenges: prize wheel (Szerencsekerék) + the game switcher ----
  'games.label': 'Games',
  'games.gifts.title': 'Gift chest',
  'games.gifts.text': 'Crosses the galaxy — the first tap takes it',
  'games.wheel.title': 'Prize wheel',
  'games.wheel.text': 'Next to your store, drawn live',
  'wheel.title': 'Prize wheel',
  'wheel.lead': 'Schedule a giveaway of your products: the wheel stands next to your store on the Outfino map, people join it in the app, and you start the draw live — fairly and verifiably.',
  'wheel.scheduleButton': 'Schedule a prize wheel',
  'wheel.oneAtATime': 'You can have one active prize wheel at a time. You can schedule a new one once this one is drawn or cancelled.',
  'wheel.scheduled': 'Scheduled! The wheel now stands next to your store on the map.',
  'wheel.updated': 'Your changes are saved.',
  'wheel.cancelled': 'The prize wheel has been cancelled.',
  'wheel.currentTitle': 'Current wheel',
  'wheel.pollingTitle': 'The page refreshes by itself — more often while the wheel is scheduled or spinning.',
  'wheel.noActive': 'You have no prize wheel on the map right now.',
  'wheel.historyTitle': 'Past wheels',
  'wheel.noHistory': 'No past prize wheels yet.',
  'wheel.status.scheduled': 'Scheduled',
  'wheel.status.drawing': 'Drawing now',
  'wheel.status.finished': 'Finished',
  'wheel.status.cancelled': 'Cancelled',
  'wheel.opensAtChip': 'Joining opens {at}',
  'wheel.joinOpen': 'Joining open',
  'wheel.edit': 'Edit',
  'wheel.cancel': 'Cancel wheel',
  'wheel.stat.untilDraw': 'Until the draw',
  'wheel.stat.spinEnds': 'Draw ends in',
  'wheel.stat.drawnAt': 'Drawn',
  'wheel.stat.participants': 'Participants',
  'wheel.stat.winners': 'Winners',
  'wheel.stat.opensIn': 'Joining opens in',
  'wheel.drawingNow': 'The wheel is spinning in the app right now.',
  'wheel.countdownDays': '{d} d {hms}',
  'wheel.lock.joined': 'People have already joined, so it can no longer be edited — you can still cancel it.',
  'wheel.lock.soon': 'It can\'t be edited in the last 10 minutes before the draw.',
  'wheel.lock.generic': 'This wheel can no longer be edited.',
  'wheel.winnersTitle': 'Winners',
  'wheel.winnersError': 'Couldn\'t load the winners right now.',
  'wheel.noParticipants': 'Nobody joined, so there was no winner.',
  'wheel.noWinners': 'No winners.',
  'wheel.noWinnersShort': 'None',
  'wheel.winnersN': '{n} winners',
  'wheel.someone': 'Someone',
  'wheel.anonymous': 'private profile',
  'wheel.round': 'Round {n}',
  'wheel.entryIndexTitle': 'The winning point\'s number on the wheel (from 0)',
  'wheel.details': 'Details',
  'wheel.cancelledAt': 'Cancelled on {at}. There was no draw.',
  'wheel.proof.title': 'Verifiable draw',
  'wheel.proof.seedHash': 'Fingerprint (seed hash)',
  'wheel.proof.seed': 'Secret key (seed)',
  'wheel.proof.seedHidden': 'Revealed after the draw',
  'wheel.proof.textScheduled': 'The fingerprint was fixed when the wheel was scheduled; its secret key is published after the draw, so nobody can bend the result afterwards.',
  'wheel.proof.textFinished': 'The secret key is public now: anyone can check that its fingerprint matches and that it gives the same winners.',
  'wheel.proof.check': 'Verify now',
  'wheel.proof.checking': 'Verifying…',
  'wheel.proof.ok': 'Verified: the fingerprint and the winners both match.',
  'wheel.proof.okHash': 'The fingerprint matches.',
  'wheel.proof.badHash': 'The fingerprint does not match the key.',
  'wheel.proof.badWinners': 'The key gives different winners.',
  'wheel.proof.checkError': 'We can\'t verify it in this browser right now.',
  'wheel.proof.copy': 'Copy {what}',
  'wheel.proof.howTitle': 'How to verify it',
  'wheel.proof.how1': 'When the wheel is scheduled, the server picks a random 32-byte key and publishes only its SHA-256 fingerprint.',
  'wheel.proof.how2': 'At the draw, the participants are numbered from 0 in the order they joined.',
  'wheel.proof.how3': 'Each round\'s winner number comes from this (an unbiased pick, earlier winners excluded):',
  'wheel.proof.how3Code': 'HMAC-SHA256(key, "{id}:<round>:<attempt>")',
  'wheel.cancelTitle': 'Cancel this prize wheel?',
  'wheel.cancelText': 'The wheel “{title}” disappears from the map at once, and the draw planned for {at} will not happen. This cannot be undone.',
  'wheel.cancelJoined': '{n} people have already joined.',
  'wheel.cancelling': 'Cancelling…',
  'wheel.cancelConfirm': 'Yes, cancel it',
  'wheel.form.createTitle': 'Schedule a prize wheel',
  'wheel.form.editTitle': 'Edit the prize wheel',
  'wheel.form.back': 'Cancel',
  'wheel.form.title': 'Title',
  'wheel.form.titlePlaceholder': 'E.g. Autumn collection giveaway',
  'wheel.form.titlePreview': 'Your wheel\'s title',
  'wheel.form.prize': 'Prize',
  'wheel.form.prizePlaceholder': 'E.g. one bag from the autumn collection, shipped free',
  'wheel.form.winners': 'Number of winners',
  'wheel.form.winnersHint': '1–{max} winners, drawn one after another.',
  'wheel.form.winnersLocked': 'Can\'t be changed after scheduling.',
  'wheel.form.less': 'Fewer',
  'wheel.form.more': 'More',
  'wheel.form.opens': 'Joining opens',
  'wheel.form.opensNow': 'Right away',
  'wheel.form.opensLater': 'Later',
  'wheel.form.opensDate': 'Opening date',
  'wheel.form.opensTime': 'Opening time',
  'wheel.form.draw': 'Draw time',
  'wheel.form.drawDate': 'Draw date',
  'wheel.form.drawTime': 'Draw time of day',
  'wheel.form.quick.inHour': 'In 1 hour',
  'wheel.form.quick.tomorrow': 'Tomorrow 20:00',
  'wheel.form.quick.week': 'In a week, 20:00',
  'wheel.form.drawHint': 'At least 10 minutes after joining opens, at most 30 days ahead.',
  'wheel.form.rules': 'I accept the game rules',
  'wheel.form.rulesHint': 'The draw follows Outfino\'s game rules; accept them to schedule the wheel.',
  'wheel.form.schedule': 'Schedule',
  'wheel.form.scheduling': 'Scheduling…',
  'wheel.form.save': 'Save',
  'wheel.form.saving': 'Saving…',
  'wheel.form.fix': 'Check the fields marked in red.',
  'wheel.form.err.titleRequired': 'Give the wheel a title.',
  'wheel.form.err.titleTooLong': '80 characters at most.',
  'wheel.form.err.prizeRequired': 'Describe what can be won.',
  'wheel.form.err.prizeTooLong': '500 characters at most.',
  'wheel.form.err.winners': 'A number from 1 to 10.',
  'wheel.form.err.opensRequired': 'Set when joining opens.',
  'wheel.form.err.drawRequired': 'Set the draw date and time.',
  'wheel.form.err.drawTooSoon': 'The draw must be at least 10 minutes after joining opens.',
  'wheel.form.err.drawTooLate': 'You can schedule at most 30 days ahead.',
  'wheel.form.err.rules': 'Accept the game rules to schedule.',
  'wheel.form.err.server': 'The server didn\'t accept this field.',
  'wheel.how.mapTitle': 'On the map.',
  'wheel.how.map': 'Once scheduled, the wheel appears next to your store on the Outfino map.',
  'wheel.how.joinTitle': 'Joining in the app.',
  'wheel.how.join': 'People join in the app, from the opening until the draw — everyone or only your followers, as you set it.',
  'wheel.how.drawTitle': 'A live draw.',
  'wheel.how.draw': 'At the draw time you start the wheel (even on a livestream); the result can be verified.',
  'wheel.preview.countLabel': 'participants',
  'wheel.preview.label': '{name} prize wheel in 3D',
  'wheel.preview.hint': 'Drag to turn',
  'wheel.preview.spin': 'Test spin',
  'wheel.preview.spinning': 'Spinning…',
  'wheel.preview.noGl': 'The 3D preview needs WebGL.',
  'wheel.preview.error': 'Couldn\'t load the preview right now.',
  'wheel.preview.drawChip': 'Draw: {at}',
  'wheel.preview.caption': 'Preview in your brand\'s colours. The dots are the people who joined ({n} here, as an example).',
  'wheel.col.drawAt': 'Draw',
  'wheel.col.wheel': 'Wheel',
  'wheel.col.status': 'Status',
  'wheel.col.participants': 'Participants',
  'wheel.col.winners': 'Winners',
  'wheel.col.details': 'Details',
  'wheel.err.activeExists': 'You can only have one active prize wheel at a time. Let the current one be drawn, or cancel it, and then schedule a new one.',
  'wheel.err.locked': 'This wheel can no longer be edited: people have joined, or the draw is close.',
  'wheel.err.notCancellable': 'This wheel can no longer be cancelled — the draw has started or finished.',
  'wheel.err.notFound': 'This prize wheel could not be found.',
  'wheel.err.invalid': 'Something in the form is not valid. Check it and try again.',
  'wheel.err.invalidField': 'The server did not accept this field: {field}.',
  'wheel.err.brandInactive': 'Your brand is not visible on Outfino right now, so it cannot schedule a prize wheel.',
  'wheel.err.notEligible': 'This brand cannot schedule a prize wheel right now.',
  'wheel.err.disabled': 'Prize wheels are not available right now.',
  'wheel.err.forbidden': 'You don’t have permission to manage prize wheels for this brand.',
  'wheel.err.brandNotFound': 'This brand could not be found.',
  'wheel.err.auth': 'Your session has expired. Please log in again.',
  'wheel.err.rateLimited': 'Too many requests at once. Wait a moment and try again.',
  'wheel.err.network': 'We can’t reach the server. Check your connection and try again.',
  'wheel.err.unavailable': 'This feature is not available here yet.',
  'wheel.err.genericCode': 'Something went wrong ({code}). Please try again.',
  'wheel.err.generic': 'Something went wrong. Please try again.',
  'wheel.free.accept': 'I understand: the winner gets the product and the shipping free, and I cover the shipping cost.',
  'wheel.form.err.freeShipping': 'Accept the free shipping to schedule.',
  'wheel.form.err.roundTooMany': 'A round can hold at most 5 different products.',
  'wheel.form.productOut': 'Unavailable',
  'wheel.err.rounds.product_not_found': 'A product in round {round} could not be found.',
  'wheel.err.rounds.product_inactive': 'A product in round {round} is not active.',
  'wheel.err.rounds.product_out_of_stock': 'A product in round {round} is out of stock.',
  'wheel.err.rounds.duplicate_product': 'Round {round} has the same product twice.',
  'wheel.err.rounds.too_many_products': 'Round {round} has too many products (5 at most).',
  'wheel.err.rounds.empty_round': 'Round {round} is empty.',
  'wheel.err.rounds.too_many_rounds': 'There can be 10 rounds at most.',
  'wheel.status.ready': 'Ready to draw',
  'wheel.free.title': 'Free prize, free shipping.',
  'wheel.free.text': 'The winner gets the product(s) free in their cart, and shipping is mandatorily free too — you cover the shipping cost.',
  'wheel.form.rounds': 'Prizes, round by round',
  'wheel.form.roundsHint': 'Each round is one spin and one winner, who gets all of the round\'s products (1 of each, up to 5 products a round). Up to 10 rounds. Only active, in-stock products can be prizes.',
  'wheel.form.roundAdd': 'Add a round',
  'wheel.form.roundUp': 'Move round {n} up',
  'wheel.form.roundDown': 'Move round {n} down',
  'wheel.form.roundRemove': 'Remove round {n}',
  'wheel.form.roundEmptyHint': 'No products yet',
  'wheel.form.productsN': '{n} products',
  'wheel.form.productsAdd': 'Add products',
  'wheel.form.productsEdit': 'Change products',
  'wheel.form.productSearch': 'Search your products',
  'wheel.form.productsPicked': '{n}/{max} selected',
  'wheel.form.productsDone': 'Done',
  'wheel.form.productsNone': 'You have no products on Outfino yet. Sync them on the Products page.',
  'wheel.form.productsNoMatch': 'No product matches.',
  'wheel.form.productsError': 'Couldn\'t load your products right now.',
  'wheel.form.productRemove': 'Remove {name}',
  'wheel.form.exclude': 'Someone who won an earlier round can\'t win again',
  'wheel.form.excludeHint': 'So every round gets a different winner.',
  'wheel.form.prizeOptional': 'Description (optional)',
  'wheel.form.prizeAutoHint': 'Leave it empty and we build it from the products.',
  'wheel.form.autoSummaryRound': 'Round {n}: {names}',
  'wheel.form.eligibility': 'Who can join?',
  'wheel.eligibility.followers_at_schedule': 'Current followers only',
  'wheel.eligibility.followers_at_scheduleHint': 'People who follow you now; new followers excluded.',
  'wheel.eligibility.followers': 'Followers',
  'wheel.eligibility.followersHint': 'New followers can join too.',
  'wheel.eligibility.everyone': 'Everyone',
  'wheel.eligibility.everyoneHint': 'Anyone can join, follower or not.',
  'wheel.excludeOn': 'One win per person',
  'wheel.excludeOff': 'Repeat wins allowed',
  'wheel.form.err.roundsCount': 'Add 1 to 10 rounds.',
  'wheel.form.err.roundEmpty': 'Put at least one product in every round.',
  'wheel.form.err.eligibility': 'Choose who can join.',
  'wheel.preview.roundsChip': '{n} rounds',
  'wheel.stat.rounds': 'Rounds',
  'wheel.stat.autoStart': 'Starts by itself in',
  'wheel.readyNow': 'Joining has closed — start the draw!',
  'wheel.prizesTitle': 'Prizes',
  'wheel.resultsTitle': 'Results by round',
  'wheel.noWinnerRound': 'No winner',
  'wheel.live.ready': 'Ready to draw',
  'wheel.live.start': 'Start the draw',
  'wheel.live.starting': 'Starting…',
  'wheel.live.waiting': 'The brand starts the draw.',
  'wheel.live.auto': 'If you don\'t start it within 30 s, it starts by itself ({s} s).',
  'wheel.live.startsIn': 'Starting in {s} s',
  'wheel.live.spinning': 'Round {n} / {total} — spinning',
  'wheel.live.roundWinner': 'Round {n} winner',
  'wheel.live.done': 'The draw is over',
  'wheel.live.fullscreen': 'Full screen',
  'wheel.live.exitFullscreen': 'Exit full screen',
  'wheel.err.notReady': 'The draw can\'t be started yet.',
  'wheel.err.alreadyDrawn': 'The draw has already started.',
  'wheel.err.products': 'One of the products can\'t be a prize. Check the rounds.',
  'wheel.err.socket': 'No live connection to the server. Try again — if you don\'t, it starts by itself after 30 s.',
  // ---- Dev banner ----
  'dev.bannerFull': 'Development mode — visit the live version here: ',
  'dev.bannerShort': 'Development mode — ',
  'dev.userBannerFull': 'Development mode — you are signed in as a dev user',
  'dev.userBannerShort': 'Dev user',

  'tab.discounts': "Discounts",
  'tab.calendar': "Event calendar",
  'tab.prizePool': "Prize Pool",
  'discounts.title': "Discounts",
  'discounts.subtitle': "Automatic discounts and coupon codes for Outfino shoppers. Everything is created in and kept in sync with your Shopify store.",
  'discounts.new': "New discount",
  'discounts.section.automatic': "Automatic discounts",
  'discounts.section.code': "Coupons",
  'discounts.empty.automatic': "No automatic discounts yet.",
  'discounts.empty.code': "No coupons yet. Create a code shoppers can enter in their cart.",
  'discounts.sync': "Sync with Shopify",
  'discounts.syncing': "Syncing…",
  'discounts.synced': "Discounts are in sync with Shopify.",
  'discounts.created': "{code} created in Shopify and Outfino.",
  'discounts.pause': "Pause",
  'discounts.resume': "Resume",
  'discounts.delete': "Delete",
  'discounts.confirmDelete': "Delete {code}? It's removed from your Shopify store too.",
  'discounts.usage': "Used {used}×",
  'discounts.usageOf': "Used {used} / {limit}",
  'discounts.minSubtotal': "Over {amount}",
  'discounts.minQuantity': "From {n} items",
  'discounts.allProducts': "All products",
  'discounts.productCount': "{n} products",
  'discounts.oncePerCustomer': "Once per customer",
  'discounts.fromShopify': "From Shopify",
  'discounts.method.automatic': "Automatic discount",
  'discounts.method.code': "Coupon code",
  'discounts.status.active': "Active",
  'discounts.status.scheduled': "Scheduled",
  'discounts.status.paused': "Paused",
  'discounts.status.expired': "Expired",
  'discounts.status.used_up': "Used up",
  'discounts.form.titleCoupon': "New coupon",
  'discounts.form.kind': "Kind",
  'discounts.form.shopify': "Shopify",
  'discounts.form.shopifySync': "Sync to Shopify",
  'discounts.form.shopifyLocal': "Outfino only",
  'discounts.form.localNote': "The discount only works on Outfino and isn't created in your Shopify store. You still pay for it from your payout.",
  'discounts.syncedShopify': "Synced to Shopify",
  'discounts.outfinoOnly': "Outfino only",
  'discounts.createdLocal': "{code} created on Outfino.",
  'discounts.confirmDeleteLocal': "Delete {code}?",
  'discounts.currency': "Store currency: {currency}",
  'discounts.form.title': "New discount",
  'discounts.form.close': "Close",
  'discounts.form.methodHint.automatic': "Applied automatically at checkout when the conditions are met — shoppers don't need a code.",
  'discounts.form.methodHint.code': "Shoppers enter the code in their cart.",
  'discounts.form.code': "Code",
  'discounts.form.codeHint': "3–32 characters: letters, numbers, - and _",
  'discounts.form.name': "Name",
  'discounts.form.nameHint': "Shown to shoppers in the cart",
  'discounts.form.namePlaceholder': "e.g. Autumn sale",
  'discounts.form.type': "Type",
  'discounts.form.typePercentage': "Percentage",
  'discounts.form.typeFixed': "Fixed amount",
  'discounts.form.valuePercent': "Discount (%)",
  'discounts.form.valueAmount': "Discount amount ({currency})",
  'discounts.form.products': "Products",
  'discounts.form.allProducts': "All products",
  'discounts.form.searchProducts': "Search your products…",
  'discounts.form.noProducts': "No products yet.",
  'discounts.form.selected': "{n} selected",
  'discounts.form.condition': "Condition",
  'discounts.form.conditionNone': "None",
  'discounts.form.conditionSubtotal': "Minimum amount",
  'discounts.form.conditionQuantity': "Minimum items",
  'discounts.form.minSubtotal': "Minimum purchase ({currency})",
  'discounts.form.minQuantity': "Minimum number of items",
  'discounts.form.usageLimit': "Total uses",
  'discounts.form.optional': "Optional",
  'discounts.form.startsAt': "Starts",
  'discounts.form.startsHint': "Empty = right away",
  'discounts.form.endsAt': "Ends",
  'discounts.form.oncePerCustomer': "One use per customer",
  'discounts.form.shopifyNote': "The discount is created in your Shopify store as well, and you pay for it from your payout.",
  'discounts.form.cancel': "Cancel",
  'discounts.form.create': "Create",
  'discounts.form.creating': "Creating…",
  'discounts.error.taken': "This code already exists.",
  'discounts.error.invalid': "Shopify refused the discount. Check the values and try again.",
  'discounts.error.reauth': "Outfino needs permission to manage discounts in your Shopify store. Open the Outfino app in Shopify and approve the updated permissions.",
  'discounts.error.createFailed': "Could not create the discount. Try again.",
  'discounts.error.syncFailed': "Could not sync with Shopify. Try again.",
  'discounts.error.updateFailed': "Could not update the discount. Try again.",
  'discounts.error.deleteFailed': "Could not delete the discount. Try again.",
  // ---- Custom brand building (3D) + support chat ----
  'shell.support': 'Support',

  'building.sectionTitle': 'How your brand appears in Outfino',
  'building.sectionLeadGeneric': 'This is the standard Outfino store on the Style Universe map, with your logo on the signs and your cover on the rooftop billboard. Drag to look around!',
  'building.sectionLeadCustom': 'Your brand’s custom building is live on the Style Universe map — this is what shoppers see. Drag to look around!',
  'building.badgeGeneric': 'Standard store',
  'building.badgeCustom': 'Custom building',
  'building.priceNoteLabel': 'Custom brand building',
  'building.cta': 'I’d like a custom-designed building in Outfino',
  'building.redesign': 'Redesign',
  'building.redesignConfirmTitle': 'Do you really want to design a new building?',
  'building.redesignConfirmBody': 'Your current building stays on the map until the new one is ready.',
  'building.redesignCancel': 'Cancel',
  'building.redesignConfirm': 'Yes, redesign it',
  'building.redesignPrefix': 'Redesign: ',
  'building.redesignNote': 'Redesign — tell us what you would change about your current building.',
  'building.openThreadTitle': 'Conversation in progress',
  'building.openThreadBody': 'We are already talking about your custom building — see the latest messages.',
  'building.openThreadLanding': 'There is already a conversation with us about your custom building. Add to or change your request there.',
  'building.openThreadCta': 'Open conversation',
  'building.viewerLabel': '{name} store in 3D',
  'building.viewerHint': 'drag to rotate',
  'building.viewerError': 'The 3D preview can’t be loaded right now.',
  'building.viewerNoGl': 'This browser does not support the 3D preview.',
  'building.closedSignText': 'Closed',
  'building.logoShapeLabel': 'Logo shape on the default store',
  'building.logoShape.round': 'Round',
  'building.logoShape.square': 'Square',
  'building.logoShape.rect': 'Rectangle',
  'building.logoShapeHint': 'The shape you pick shows in the preview right away, and on the map too.',
  'building.logoShapeReadOnly': 'The logo shape can be changed by members with edit access.',
  'building.logoShapeSaving': 'Saving…',
  'building.logoShapeSaved': 'Saved — the map shows this shape too.',
  'building.logoShapeError': 'Could not save, so we put the previous shape back. Please try again.',
  'building.closedInactive': 'Your store currently shows as Closed on the map because your brand is inactive.',
  'building.closedNoShopify': 'Your store currently shows as Closed on the map because there is no active Shopify connection.',
  'building.closedGeneric': 'Your store currently shows as Closed on the map.',
  'building.closedHintInactive': 'Turn on “Brand is visible in Outfino” below, or get in touch with us — then the store opens again.',
  'building.closedHintNoShopify': 'Connect your Shopify store to Outfino (the Outfino app in your Shopify admin) — the store then opens by itself.',
  'building.closedCtaShopify': 'Connect Shopify',
  'building.previewToggle': 'Open / Closed preview',
  'building.previewOpen': 'Open',
  'building.previewClosed': 'Closed',
  // ---- Style category: which Style Universe galaxy the store stands in ----
  'styleCategory.label': 'Style category',
  'styleCategory.explainer': 'This decides which style galaxy your store stands in on the map.',
  'styleCategory.prompt': 'Pick your style so your store lands in the right galaxy.',
  'styleCategory.saving': 'Saving…',
  'styleCategory.saved': 'Saved — your store now stands in the {galaxy} galaxy.',
  'styleCategory.error': 'Could not save, so we put the previous category back. Please try again.',
  'styleCategory.readOnly': 'Changing the style category needs edit permission.',
  'styleCategory.readOnlyNone': 'No style category picked yet. Setting it needs edit permission.',
  'styleCategory.name.streetwear': 'Streetwear',
  'styleCategory.name.techwear': 'Techwear',
  'styleCategory.name.goth_alt': 'Goth / Alt',
  'styleCategory.name.experimental': 'Experimental',
  'styleCategory.name.y2k': 'Y2K',
  'styleCategory.name.sporty': 'Sporty',
  'styleCategory.name.casual': 'Casual',
  'styleCategory.name.boho_indie': 'Boho / Indie',
  'styleCategory.name.minimalist': 'Minimalist',
  'styleCategory.name.old_money': 'Old Money',
  'styleCategory.name.vintage_retro': 'Vintage / Retro',

  'building.backToProfile': 'Back to profile',
  'building.eyebrow': 'Style Universe · Custom brand building',
  'building.heroTitle': 'A building of your own in the Outfino galaxy',
  'building.heroLead': 'Instead of the standard store, your brand gets a made-to-measure 3D building on the Style Universe map — in your own shapes, materials and colours. Shoppers recognise you from afar.',
  'building.priceLabel': 'Price',
  'building.priceFrom': 'from HUF {price} (gross)',
  'building.heroCta': 'Request a custom building',
  'building.heroCtaRedesign': 'Request a redesign',
  'building.heroGallery': 'See the gallery',
  'building.processTitle': 'How it works',
  'building.processLead': 'We send you 3 design variants, then you can ask for 2 more rounds of changes.',
  'building.step1Title': 'Tell us what you want',
  'building.step1Body': 'Describe the building you imagine and add references (photos, Pinterest, your shop).',
  'building.step2Title': '3 design variants',
  'building.step2Body': 'Our designer creates three different concepts from your brand identity.',
  'building.step3Title': '2 revision rounds',
  'building.step3Body': 'Ask for changes to the variant you pick, in up to two rounds.',
  'building.step4Title': 'Live on the map',
  'building.step4Body': 'The finished building goes live on the Style Universe map with your logo and cover.',
  'building.galleryTitle': 'Custom buildings in Outfino',
  'building.galleryLead': 'These brands already have a building of their own. Click one to look around in 3D.',
  'building.galleryOpen': 'Open the {name} building in 3D',
  'building.galleryEmptyTitle': 'No custom buildings yet',
  'building.galleryEmptyBody': 'Make yours the first on the Style Universe map!',
  'building.galleryError': 'The gallery can’t be loaded right now.',
  'building.retry': 'Retry',
  'building.close': 'Close',
  'building.formTitle': 'Request your custom building',
  'building.formTitleRedesign': 'Request a redesign of your building',
  'building.formLead': 'Prices start from HUF {price} (gross). Your request opens a conversation with our team in Support, where we agree the details and the quote.',
  'building.fieldDescription': 'What kind of building would you like?',
  'building.fieldDescriptionHint': 'E.g. “A black two-storey mini villa with a glass front, light oak shelves inside…” — shape, materials, colours, mood, anything that matters.',
  'building.fieldDescriptionError': 'Write at least a few words about what you want.',
  'building.fieldLinks': 'Reference links',
  'building.fieldLinksHint': 'Optional. Pinterest, Instagram, photos of your shop, buildings you like.',
  'building.linkAdd': 'Add link',
  'building.linkRemove': 'Remove link',
  'building.fieldEmail': 'Contact email',
  'building.submit': 'Start the conversation',
  'building.submitRedesign': 'Request redesign',
  'building.submitFine': 'Sending commits you to nothing — we quote first.',
  'building.sending': 'Sending…',
  'building.sendError': 'Could not send it. Please try again a little later.',

  'support.title': 'Support',
  'support.lead': 'Write to us about anything — your conversations live here, and this is where we reply.',
  'support.new': 'New conversation',
  'support.listLabel': 'Conversations',
  'support.noThreads': 'No conversations yet.',
  'support.listError': 'Conversations can’t be loaded right now.',
  'support.topic.general': 'General question',
  'support.topic.brand_building': 'Custom brand building',
  'support.closed': 'Closed',
  'support.pickTitle': 'Pick a conversation',
  'support.pickBody': 'or start a new one with the button at the top right.',
  'support.back': 'Conversations',
  'support.newTitle': 'New conversation',
  'support.newLead': 'How can we help? Our team replies here.',
  'support.newLabel': 'Message',
  'support.newHint': 'Describe your question…',
  'support.start': 'Send',
  'support.sending': 'Sending…',
  'support.sendError': 'Could not send it. Please try again.',
  'support.conversation': 'Conversation',
  'support.started': 'Started {date}',
  'support.createdNotice': 'Got it — we’ll be in touch soon! You’ll find our reply right here.',
  'support.noMessages': 'No messages yet.',
  'support.notFound': 'This conversation could not be found.',
  'support.loadError': 'New messages can’t be loaded right now.',
  'support.outfinoTeam': 'Outfino team',
  'support.composerHint': 'Write a message…',
  'support.closedHint': 'Closed conversation — writing here starts a new one.',
  'support.send': 'Send',
  'building.sendInvalid': 'Something is off with the details — check the description and the links (http/https).',
  'support.alreadyOpenNotice': 'There is already a conversation about this — continue it here.',
  'support.retry': 'Not sent — retry',
  // ---- QA fixes (fix/ui-qa-contrast): confirmations, payout states ----
  'nav.demo': 'Get started',
  'confirm.back': 'Cancel',
  'drops.cancelConfirmTitle': 'Delete this drop?',
  'drops.cancelConfirmBody': 'The scheduled drop of “{name}” is removed and will not appear in the app.',
  'drops.cancelConfirm': 'Delete drop',
  'members.removeConfirmTitle': 'Remove this member?',
  'members.removeConfirmBody': '{name} loses access to the brand.',
  'payouts.confirmTitle': 'Request payout',
  'payouts.confirmBody': 'You are requesting your whole available balance ({amount}). Once requested, it becomes pending.',
  'payouts.pendingBlocks': 'You already have a pending payout request — you can send a new one once it has been settled.',
  'payouts.status.pending': 'Pending',
  'payouts.status.processing': 'Processing',
  'payouts.status.completed': 'Paid out',
  'payouts.status.failed': 'Failed',
  'payouts.status.cancelled': 'Cancelled',

  // ── Fit-check embed (Statistics / Visitors / Settings) ──
  'tab.embedded-settings': 'Settings',
  'embed.range.label': 'Period',
  'embed.range.days': '{n} days',
  'embed.range.custom': 'Custom',
  'embed.range.from': 'From',
  'embed.range.to': 'To',
  'embed.mock.badge': 'Test data',
  'embed.mock.title': 'This is test data, not real traffic.',
  'embed.error.load': 'Could not load the data. Try again with the Refresh button.',
  'embed.error.forbidden': "You don't have access to this page for this brand.",
  'embed.empty.range': 'No data for this period yet.',
  'embed.copy.button': 'Copy',
  'embed.copy.codeDone': 'Embed code copied to the clipboard',
  'embed.copy.failed': 'Copying failed. Select the code and copy it by hand.',

  'embed.stats.title': 'Fit-check button statistics',
  'embed.stats.lead': 'What the "See if it suits you" button did on your product pages: how many people saw it, clicked, signed in, uploaded photos and opened the product matching.',
  'embed.kpi.impressions': 'Impressions',
  'embed.kpi.clicks': 'Clicks',
  'embed.kpi.signups': 'Sign-ups',
  'embed.kpi.logins': 'Logins',
  'embed.kpi.matchViews': 'Matching views',
  'embed.kpi.uploadSessions': 'Uploads',
  'embed.kpi.photosUploaded': 'Photos uploaded',
  'embed.kpi.uniqueVisitors': 'Unique visitors',
  'embed.kpi.ctr': 'Click-through: {pct}',
  'embed.kpi.perUpload': '{n} photos per upload on average',
  'embed.funnel.title': 'Funnel',
  'embed.funnel.impressions': 'Impression',
  'embed.funnel.clicks': 'Click',
  'embed.funnel.signIns': 'Sign-up or login',
  'embed.funnel.matchViews': 'Product matching view',
  'embed.funnel.conv': '{pct} of the previous step',
  'embed.funnel.signInsHint': '{signups} new · {logins} returning',
  'embed.funnel.uploadSessions': 'uploads',
  'embed.funnel.photos': 'photos uploaded',
  'embed.funnel.uploadRate': 'of signed-in visitors uploaded photos',
  'embed.chart.title': 'Daily trend',
  'embed.chart.metricLabel': 'Metric',
  'embed.chart.metric.impressions': 'Impressions',
  'embed.chart.metric.clicks': 'Clicks',
  'embed.chart.metric.signIns': 'Sign-ups + logins',
  'embed.chart.metric.matchViews': 'Matching views',
  'embed.chart.metric.photosUploaded': 'Photos uploaded',
  'embed.chart.showTable': 'Daily breakdown as a table',
  'embed.chart.hideTable': 'Hide table',
  'embed.chart.date': 'Day',
  'embed.top.title': 'Products',
  'embed.top.lead': 'Which product page brought the sign-ups, matching views and uploaded photos, and how well the products suited the visitors.',
  'embed.top.product': 'Product',
  'embed.top.col.impressions': 'Impressions',
  'embed.top.col.clicks': 'Clicks',
  'embed.top.col.signups': 'Sign-ups',
  'embed.top.col.matchViews': 'Matching',
  'embed.top.col.photosUploaded': 'Photos',
  'embed.top.col.avgCompatibility': 'Avg. compatibility',

  'embed.visitors.title': 'Visitors',
  'embed.visitors.lead': 'Who did what with the button, at which of your products. Only signed-in Outfino users are listed here; anonymous carts and purchases show in the Statistics totals.',
  'embed.visitors.product': 'Product',
  'embed.visitors.allProducts': 'All products',
  'embed.visitors.event': 'Event',
  'embed.visitors.allEvents': 'All events',
  'embed.visitors.empty': 'No visitors match these filters in this period.',
  'embed.visitors.shown': '{n} events',
  'embed.visitors.more': 'Load more',
  'embed.visitors.col.user': 'User',
  'embed.visitors.col.event': 'Event',
  'embed.visitors.col.product': 'Product',
  'embed.visitors.col.photos': 'Photos',
  'embed.visitors.col.compat': 'Compatibility',
  'embed.visitors.col.time': 'Time',
  'embed.event.signup': 'Signed up for Outfino',
  'embed.event.login': 'Logged in',
  'embed.event.match_view': 'Viewed the product matching',
  'embed.event.uploadOne': 'Uploaded 1 photo',
  'embed.event.upload': 'Uploaded {n} photos',
  'embed.eventFilter.signup': 'Sign-up',
  'embed.eventFilter.login': 'Login',
  'embed.eventFilter.upload': 'Photo upload',
  'embed.eventFilter.match_view': 'Product matching view',

  'embed.settings.title': 'Fit-check button settings',
  'embed.status.configured': 'Set up',
  'embed.status.notConfigured': 'Not set up',
  'embed.status.lastSeen': 'Last seen on a live page: {ago}',
  'embed.status.notConfiguredHint': "We haven't seen the button on a live page in the last 7 days. Add it with the code below and it shows up here within minutes.",
  'embed.status.domainMeta': '{ago} · {n} impressions in the last 7 days',
  'embed.key.label': 'Embed key',
  'embed.key.masked': 'Embed key, partly hidden',
  'embed.key.copyCode': 'Copy embed code',
  'embed.key.allowed': 'Allowed domains: {domains}',
  'embed.design.title': 'Button design',
  'embed.design.lead': "Pick the one that suits your store's theme. The previews show the live button.",
  'embed.design.gallery': 'Shape and colour',
  'embed.design.shape.pill': 'Pill',
  'embed.design.shape.rounded': 'Rounded',
  'embed.design.shape.square': 'Square',
  'embed.design.theme.dark': 'Dark button',
  'embed.design.theme.light': 'Light button',
  'embed.design.variant': 'Width',
  'embed.design.variant.compact': 'Compact',
  'embed.design.variant.full': 'Full width',
  'embed.design.height': 'Height',
  'embed.design.lang': 'Language',
  'embed.design.lang.auto': 'Automatic (recommended)',
  'embed.design.langNote': "The button shows in the visitor's language automatically: Hungarian in a Hungarian browser, English everywhere else. This is the default in the copied code (lang=auto).",
  'embed.design.langForced': 'Every visitor sees the button in {lang}. With the automatic setting everyone sees it in their own language.',
  'embed.design.preview': 'Preview',
  'embed.design.visitor.hu': 'Hungarian visitor',
  'embed.design.visitor.en': 'Visitor in any other language',
  'embed.install.title': 'Add it to your store',
  'embed.install.platform': 'Platform',
  'embed.install.shopify': 'Shopify (Liquid)',
  'embed.install.html': 'Other webshop (HTML)',
  'embed.install.code': 'Embed code',
  'embed.install.liquid.title': 'Custom Liquid block',
  'embed.install.liquid.lead': 'Works in any Shopify theme, by pasting.',
  'embed.install.liquid.step1': 'In the Shopify admin: Online Store → Customize → Product page.',
  'embed.install.liquid.step2': 'Add block → Custom Liquid, where the button should go (e.g. under Add to cart).',
  'embed.install.liquid.step3': 'Paste the code below and save.',
  'embed.install.liquid.vars': "The code takes the product's details from Shopify's variables: {{ product.id }}, {{ product.handle }}, {{ shop.permanent_domain }} and the product's featured image.",
  'embed.install.html.step1': 'Copy the code below.',
  'embed.install.html.step2': 'Paste it into your product page template, where the button should go.',
  'embed.install.html.step3': "Replace the placeholders with the product's details (using your webshop's template variables).",
  'embed.install.ph.id': 'the product id (digits only)',
  'embed.install.ph.handle': 'the product URL slug (e.g. organic-cotton-tee)',
  'embed.install.ph.img': 'the product image https URL, URL-encoded',

  // ── Fit-check embed: SRC, carts + purchases, the pixel ──
  'embed.copy.srcDone': 'SRC copied to the clipboard',
  'embed.copy.snippetDone': 'Copied: {what}',
  'embed.key.copySrc': 'Copy SRC',
  'embed.key.srcLabel': 'Iframe SRC · {platform}',
  'embed.kpi.addToCarts': 'Add to cart',
  'embed.kpi.purchases': 'Purchases',
  'embed.kpi.revenueMatched': 'Revenue with matching',
  'embed.kpi.ofWhichMatched': 'with matching: {n}',
  'embed.kpi.revenueHint': 'Purchases where the buyer viewed the matching for that product first',
  'embed.funnel.addToCartsMatched': 'Added to cart (with matching)',
  'embed.funnel.purchasesMatched': 'Purchased (with matching)',
  'embed.funnel.allCarts': 'all add-to-carts: {n}',
  'embed.funnel.allPurchases': 'all purchases: {n}',
  'embed.chart.metric.addToCarts': 'Add-to-carts',
  'embed.chart.metric.purchases': 'Purchases',
  'embed.top.col.addToCarts': 'Cart',
  'embed.top.col.purchases': 'Purchases',
  'embed.top.col.revenueMatched': 'Revenue',
  'embed.top.matched': '{n} with matching',
  'embed.event.add_to_cart': 'Added to cart',
  'embed.event.purchase': 'Purchased',
  'embed.eventFilter.add_to_cart': 'Add to cart',
  'embed.eventFilter.purchase': 'Purchase',
  'embed.visitors.qty': '{n} pcs',
  'embed.visitors.matched': 'with matching',
  'embed.visitors.matchedTitle': 'Viewed the product matching for this product first (within 30 days)',
  'embed.tracking.title': 'Cart and purchase tracking',
  'embed.tracking.lead': 'The Outfino pixel measures add-to-carts and purchases in any webshop. In the statistics the totals are every cart and purchase the pixel saw (anonymous visitors included); "with matching" are those where the same visitor viewed the product matching for that product in the 30 days before. The Visitors list shows signed-in Outfino users only.',
  'embed.tracking.platform.shopify': 'Shopify',
  'embed.tracking.platform.woocommerce': 'WooCommerce',
  'embed.tracking.platform.html': 'Other webshop (HTML)',
  'embed.tracking.lastCart': 'Last add to cart: {ago}',
  'embed.tracking.lastPurchase': 'last purchase: {ago}',
  'embed.tracking.notConfiguredHint': 'No cart or purchase events yet. Turn it on as below.',
  'embed.tracking.seenOn': 'Seen on:',
  'embed.tracking.seen.shopify': 'Shopify',
  'embed.tracking.seen.woocommerce': 'WooCommerce',
  'embed.tracking.seen.custom': 'Custom',
  'embed.tracking.shopify.step1': 'Add-to-cart on every page: Online Store → Themes → Edit code → theme.liquid. Paste this line before </body> and save.',
  'embed.tracking.shopify.step2': 'Purchases: Settings → Customer events → Add custom pixel. Name it "Outfino" and paste this code (your key is already in it).',
  'embed.tracking.woo.step1': 'Add these two lines once, to every page (e.g. with a "header/footer scripts" plugin).',
  'embed.tracking.woo.step1b': "Or without a plugin, in the theme's functions.php:",
  'embed.tracking.woo.phpTitle': 'Optional: PHP snippet for the thank-you page',
  'embed.tracking.woo.phpLead': "For the exact items and value, in the theme's functions.php or a small plugin. Without it the pixel reads the order number and total from the thank-you page.",
  'embed.tracking.html.step1': 'Put these two lines on every page of your shop, before </head>.',
  'embed.tracking.html.step2': 'Add to cart: either a data attribute on the cart button, or a call from your own cart code.',
  'embed.tracking.html.step3': 'Purchase: on the order confirmation page, once, with the order.',
  'embed.tracking.code.pixel': 'Pixel',
  'embed.tracking.code.php': 'PHP snippet',
  'embed.tracking.code.addToCart': 'Add to cart',
  'embed.tracking.code.purchase': 'Purchase',
  'embed.tracking.code.consent': 'Consent',
  'embed.tracking.consent': "In the EU, tracking may only start after the visitor's consent; until then the pixel stores and sends nothing. It follows the Shopify Customer Privacy API, the WP Consent API, Google Consent Mode and the common consent tools (Cookiebot, OneTrust, CookieYes) automatically. If none is on the page, call this after consent (false when they refuse):",
  'embed.tracking.shopify.detects': "Detects the theme's AJAX and form add-to-cart; consent follows the Shopify Customer Privacy API.",
  'embed.tracking.woo.detects': 'Detects archive AJAX and single-product add-to-cart, the Cart/Checkout blocks, and the order-received page.',
  'embed.tracking.code.functions': 'functions.php',
  'embed.tracking.code.addToCartAttr': 'Cart button (data attribute)',
  'embed.kpi.allSeen': 'all the pixel saw',
  'embed.tracking.shopify.step2b': 'Permission: Analytics, then Save and Connect.',
  'embed.tracking.code.customPixel': 'Custom pixel',
  'embed.tracking.products': 'The pixel reads the products from the page itself (Shopify catalog, WooCommerce Store API, schema.org JSON-LD), so no product sync is needed.',
  'embed.kpi.follows': 'New followers (from the iframe)',
  'embed.funnel.follows': 'follows',
  'embed.chart.metric.follows': 'New followers',
  'embed.top.col.follows': 'Follows',
  'embed.event.follow': 'Started following the brand',
  'embed.eventFilter.follow': 'Follow',
  'embed.copy.keyDone': 'Key copied to the clipboard',
  'embed.key.copyKey': 'Copy key',
  'embed.install.block.title': 'Outfino app block',
  'embed.install.block.lead': 'With the Outfino Shopify app installed, the button is a block in the theme editor.',
  'embed.install.block.step1': 'In the Shopify admin: Online Store → Customize.',
  'embed.install.block.step2': 'Pick the Product page template at the top, then Add block → Outfino.',
  'embed.install.block.step3': 'Paste your key into the block\'s "Embed key" field.',
  'embed.install.block.step4': 'Set the same shape, colour, width and height you picked above, then save.',
  'embed.tracking.app.title': 'Outfino app',
  'embed.tracking.app.lead': 'With the Outfino Shopify app installed.',
  'embed.tracking.app.step1': 'Online Store → Customize → App embeds.',
  'embed.tracking.app.step2': 'Turn on "Outfino tracking", then save.',
  'embed.tracking.app.checkout': "Orders placed at checkout are sent by the Outfino app's Web Pixel automatically.",
  'embed.tracking.paste.title': 'By pasting',
  'embed.tracking.paste.lead': 'Without the app, in any Shopify theme.',
  'embed.visitors.guest': 'Guest',
  'embed.visitors.anonymous': 'Visitor',
  'embed.tracking.inactive': 'Not active',
  'embed.tracking.inactiveHint': 'No cart or purchase events in the last 7 days.',
  'embed.product.untitled': 'Product #{id}',

  // ── Profile / Followers / Billing (top-level brand pages) ──
  'tab.followers': 'Followers',
  'tab.billing': 'Billing',

  'brandProfile.title': 'Brand profile',
  'brandProfile.logo': 'Logo',
  'brandProfile.logoAdd': 'Add logo',
  'brandProfile.logoChange': 'Replace logo',
  'brandProfile.logoHint': 'Shown as a circle. A square image works best.',
  'brandProfile.cover': 'Cover image',
  'brandProfile.coverAdd': 'Add cover image',
  'brandProfile.coverChange': 'Replace cover image',
  'brandProfile.nameRequired': 'The brand name cannot be empty.',
  'brandProfile.preview': 'Preview',
  'brandProfile.previewChip': 'In the fit-check button',
  'brandProfile.previewHeader': 'Header with the cover image',
  'brandProfile.tone.light': 'Light',
  'brandProfile.tone.dark': 'Dark',
  'brandProfile.follow': 'Follow',

  'followers.title': 'Followers',
  'followers.lead': 'Who follows the brand, from the app or from the fit-check button.',
  'followers.count': 'followers',
  'followers.matches': 'matches',
  'followers.search': 'Search by username',
  'followers.empty': 'No followers yet.',
  'followers.noMatch': 'No follower with that name.',
  'followers.col.user': 'User',
  'followers.col.source': 'Source',
  'followers.col.since': 'Following since',
  'followers.source.app': 'From the app',
  'followers.source.embed': 'From the fit-check button',
  'followers.anon': 'Hidden profile',
  'followers.anonTitle': 'This user is not shown by name.',
  'followers.shown': '{n} of {total} shown',
  'followers.more': 'Load more',

  'billing.loadError': 'Could not load the billing details. Try again with Refresh.',
  'billing.readOnly': 'The brand owner can change the card and the billing details.',
  'billing.readOnlyOwner': 'Billing is managed by the brand owner.',
  'billing.cancel': 'Cancel',
  'billing.term': 'unique matching',
  'billing.terms': 'unique matchings',
  'billing.termTip': 'One user counts once per product within 30 days.',
  'billing.price.title': 'Pricing',
  'billing.price.base': 'Monthly fee: {fee} (the first month is free)',
  'billing.price.included': '{n} {terms} included',
  'billing.price.overage': 'then {price} per {term} (at most {cap} a month)',
  'billing.price.commission': '{rate} commission on purchases tied to a matching',
  'billing.usage.title': 'This month',
  'billing.usage.period': 'Month',
  'billing.usage.includedOf': '{terms}',
  'billing.usage.over': '+{n} over the included',
  'billing.usage.meterLabel': 'Unique matchings used of those included in the monthly fee',
  'billing.usage.baseFee': 'Monthly fee',
  'billing.usage.trial': 'Trial month',
  'billing.usage.overage': 'Extra matchings',
  'billing.usage.overageCalc': '{n} × {price}, at most {cap}',
  'billing.usage.overageNone': 'Within the included matchings (at most {cap})',
  'billing.usage.capReached': 'monthly cap reached',
  'billing.usage.commission': 'Commission ({rate})',
  'billing.usage.commissionCalc': '{n} purchases tied to a matching, {revenue} in sales',
  'billing.usage.estimated': 'Estimated total',
  'billing.usage.total': 'Month total',

  'billing.card.title': 'Card',
  'billing.card.lead': 'We charge the monthly fee to this card.',
  'billing.card.none': 'No card added yet.',
  'billing.card.generic': 'Card',
  'billing.card.expires': 'Expires {date}',
  'billing.card.expired': 'Expired {date}',
  'billing.card.add': 'Add card',
  'billing.card.replace': 'Replace card',
  'billing.card.remove': 'Remove',
  'billing.card.removeConfirm': 'Remove the card? Without a card we cannot charge the monthly fee.',
  'billing.card.removeConfirmGate': 'Remove the card? Without a card the portal is closed until you add a new one.',
  'billing.card.removeYes': 'Remove',
  'billing.card.removing': 'Removing…',
  'billing.card.removed': 'Card removed',
  'billing.card.removeFailed': 'Could not remove the card. Try again.',
  'billing.card.save': 'Save card',
  'billing.card.saving': 'Saving…',
  'billing.card.saved': 'Card saved',
  'billing.card.saveFailed': 'The bank accepted the card, but saving it failed. Try again.',
  'billing.card.failed': 'The card could not be verified. Try again or use another card.',
  'billing.card.processing': 'The bank is still processing the card. Refresh the page in a few minutes.',
  'billing.card.unavailable': 'Adding a card is not available right now. Try again later.',

  'billing.mock.note': 'Test mode: no Stripe connection, nothing is charged. Test numbers: 4242 4242 4242 4242 (succeeds), 4000 0027 6000 3184 (3D Secure), 4000 0000 0000 0002 (declined).',
  'billing.mock.number': 'Card number',
  'billing.mock.expiry': 'Expiry',
  'billing.mock.expiryPh': 'MM / YY',
  'billing.mock.badNumber': 'Invalid card number.',
  'billing.mock.badExpiry': 'Invalid or past date.',
  'billing.mock.badCvc': 'Invalid CVC.',
  'billing.mock.declined': 'The card was declined.',
  'billing.mock.3dsTitle': 'Confirm with your bank',
  'billing.mock.3dsBody': 'Your bank asks you to confirm this card (3D Secure).',
  'billing.mock.3dsApprove': 'Confirm',
  'billing.mock.3dsReject': 'Decline',
  'billing.mock.3dsFailed': '3D Secure authentication failed. Try again or use another card.',

  'billing.details.title': 'Billing details',
  'billing.details.name': 'Company name',
  'billing.details.email': 'Billing e-mail',
  'billing.details.taxId': 'Tax number / VAT ID',
  'billing.details.taxIdPh': '12345678-2-42 or HU12345678',
  'billing.details.line1': 'Address',
  'billing.details.line2': 'Address line 2',
  'billing.details.postalCode': 'Postal code',
  'billing.details.city': 'City',
  'billing.details.country': 'Country',
  'billing.details.save': 'Save details',
  'billing.details.saved': 'Billing details saved',
  'billing.details.saveFailed': 'Could not save the billing details.',
  'billing.details.required': 'Required.',
  'billing.details.badEmail': 'Invalid e-mail address.',

  'billing.invoices.title': 'Invoices',
  'billing.invoices.empty': 'No invoices yet.',
  'billing.invoices.number': 'Invoice',
  'billing.invoices.period': 'Period',
  'billing.invoices.amount': 'Amount',
  'billing.invoices.status': 'Status',
  'billing.invoices.download': 'Download',
  'billing.invoices.st.paid': 'Paid',
  'billing.invoices.st.open': 'Due',
  'billing.invoices.st.draft': 'Being prepared',
  'billing.invoices.st.void': 'Voided',
  'billing.invoices.st.uncollectible': 'Charge failed',

  // ── Card gate (REQUIRE_VALID_CARD) ──
  'gate.title.missing': 'Add your card to get started',
  'gate.title.expired': 'Your card has expired',
  'gate.title.failed': 'The last charge did not go through',
  'gate.lead.missing': 'The portal opens with a verified card. The first month is free.',
  'gate.lead.expired': 'The card saved for this brand has expired. Add a new card to open the portal again.',
  'gate.lead.failed': 'The last charge to this card did not go through. Add a new card to open the portal again.',
  'gate.current': 'Saved card: •••• {last4}',
  'gate.newCard': 'Add a new card',
  'gate.memberTitle': 'The portal is not open yet',
  'gate.member': 'The brand owner has not added a card yet. Ask them so the portal opens.',
  'gate.otherBrand': 'Another brand',
  'gate.notValid.missing': 'The card could not be verified. Try again or use another card.',
  'gate.notValid.expired': 'The card has expired. Use another card.',
  'gate.notValid.failed': 'The bank did not accept the card. Use another card.',
  'gate.checkFailed': 'Could not check the card. Try again.',
  'gate.adminBanner': 'No valid card',
  'gate.status.missing': 'the brand has not added a card (you are in as an admin)',
  'gate.status.expired': "the brand's card has expired (you are in as an admin)",
  'gate.status.failed': 'the last charge did not go through (you are in as an admin)',
  'gate.errorTitle': 'Could not load billing',
  'gate.errorBody': 'Try again in a few seconds.',
  'gate.retry': 'Retry',
};

export default en;
